import { EVENTS } from "../../../js/constants";

class Search {
  /**
   * @param {HTMLElement} element - the search form element
   */
  constructor(element) {
    this.element = element;
    this.multiselects = [...this.element.querySelectorAll(".js-MultiSelect")];

    if (this.multiselects.length) {
      this._bind();
    }
  }

  /**
   * binds event listener
   */
  _bind() {
    this.multiselects.forEach((multiselect) => {
      multiselect.addEventListener(EVENTS.MULTISELECT_RESET, () => {
        this._submitForm();
      });
    });
  }

  /**
   * submit form when multiselect was reset
   */
  _submitForm() {
    this.element.submit();
  }
}

export default Search;
